import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-jakarta',
  standalone: true,
  imports: [],
  templateUrl: './jakarta.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './jakarta.component.scss'
})
export class JakartaComponent {

}
